import { NumberField as BaseNumberField } from '@base-ui/react/number-field';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Input, type InputProps } from '@/components/ui/Input';
import { cx } from '@/cva.config';

export interface NumberFieldProps {
  className?: string;
  disabled?: boolean;
  font?: InputProps['font'];
  format?: Intl.NumberFormatOptions;
  max?: number;
  min?: number;
  onValueChange: (value: number | null) => void;
  placeholder?: string;
  size?: InputProps['size'];
  step?: number;
  value: number | null;
}

export const NumberField = ({
  className,
  disabled,
  font,
  format,
  max,
  min,
  onValueChange,
  placeholder,
  size,
  step,
  value,
}: NumberFieldProps) => (
  <BaseNumberField.Root
    className={cx('flex w-full', className)}
    disabled={disabled}
    format={format}
    max={max}
    min={min}
    onValueChange={onValueChange}
    step={step}
    value={value}
  >
    <BaseNumberField.Group className="relative flex items-stretch w-full">
      <BaseNumberField.Input
        placeholder={placeholder}
        render={<Input className="pr-7 w-full" font={font} size={size} />}
      />
      <div className="absolute inset-y-0 right-0 flex flex-col border-l border-border">
        <BaseNumberField.Increment className="flex flex-1 items-center justify-center px-1 text-foreground-muted hover:text-foreground">
          <ChevronUp className="size-3" />
        </BaseNumberField.Increment>
        <BaseNumberField.Decrement className="flex flex-1 items-center justify-center border-t border-border px-1 text-foreground-muted hover:text-foreground">
          <ChevronDown className="size-3" />
        </BaseNumberField.Decrement>
      </div>
    </BaseNumberField.Group>
  </BaseNumberField.Root>
);
